import React from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants";
import { useTranslation } from "react-i18next";
import AuthPageLayout from "../../../components/layout/AuthPageLayout";
import { images } from "../../../assets";
import {
  SuccessContainer,
  SuccessIcon,
  SuccessTitle,
  SuccessSubtitle,
  SuccessActions,
} from "./RegistrationSuccessPage.styled";

const RegistrationSuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoTo2FA = () => {
    navigate(ROUTES.TWO_FACTOR_AUTH);
  };

  return (
    <AuthPageLayout>
      <SuccessContainer>
        <SuccessIcon>
          <Box
            component="img"
            src={images.diamond}
            alt="Success icon"
            sx={{ width: "120px", height: "120px" }}
          />
        </SuccessIcon>

        <SuccessTitle>{t("registrationSuccess.title")}</SuccessTitle>

        <SuccessSubtitle>{t("registrationSuccess.subtitle")}</SuccessSubtitle>

        <SuccessActions>
          <Button
            variant="contained"
            onClick={handleGoTo2FA}
            sx={{ minWidth: 200 }}
          >
            {t("registrationSuccess.goTo2FA")}
          </Button>
        </SuccessActions>
      </SuccessContainer>
    </AuthPageLayout>
  );
};

export default RegistrationSuccessPage;
